module.exports = __webpack_public_path__ + "img/icon_sites.550d8bec.png";